"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformUserToContact = void 0;
const class_transformer_1 = require("class-transformer");
const Contact_1 = require("../models/Contact");
const transformUserBirthdayToDate_1 = require("./transformUserBirthdayToDate");
function transformUserToContact(user) {
    const rawContact = {
        birthdayAt: (0, transformUserBirthdayToDate_1.transformUserBirthdayToDate)(user.birthdayAt),
        countryId: user.countryId,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        phoneNumber: user.phoneNumber,
    };
    return (0, class_transformer_1.plainToClass)(Contact_1.Contact, rawContact);
}
exports.transformUserToContact = transformUserToContact;
//# sourceMappingURL=transformUserToContact.js.map